import styled from 'styled-components';

// Card and card-heading styles shared by the My Account page's sections.
export const Wrapper = styled.div`
  margin-top: 0;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 24px 24px 24px;
  margin-bottom: 32px;
`;

export const Header1 = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #479de6;
`;
